import { composeLayers } from './compose.js';
/**
 * 레이어 체인을 `globalThis.fetch` 위에 합성해 HTTP 클라이언트를 만든다.
 * 앞에 넘긴 레이어가 바깥(요청 진입) 쪽에 온다.
 */
export function buildClient(...layers) {
    return composeLayers(...layers)(globalThis.fetch);
}
//# sourceMappingURL=client.js.map